import React from 'react';
import { FiExternalLink, FiShoppingCart, FiTag } from 'react-icons/fi';
import '../styles/ProductCard.css';

const ProductCard = ({ product }) => {
  console.log('Rendering ProductCard:', product?.name);
  
  const handleViewProduct = () => {
    window.open(product.permalink, '_blank');
  };

  // Strip HTML tags from description
  const stripHtml = (html) => {
    const tmp = document.createElement('div');
    tmp.innerHTML = html || '';
    return tmp.textContent || tmp.innerText || '';
  };

  const hasDiscount = product.sale_price && product.sale_price !== product.regular_price;

  if (!product) {
    console.error('ProductCard received null/undefined product');
    return null;
  }

  return (
    <div className="product-card" onClick={handleViewProduct}>
      <div className="product-image-wrapper">
        {hasDiscount && (
          <div className="sale-badge">
            <FiTag size={12} /> SALE
          </div>
        )}
        {product.image ? (
          <img 
            src={product.image} 
            alt={product.name}
            className="product-image"
            loading="lazy"
            onError={(e) => {
              e.target.src = 'https://via.placeholder.com/300x300?text=No+Image';
            }}
          />
        ) : (
          <div className="product-image-placeholder">
            <FiShoppingCart size={40} />
          </div>
        )}
        {product.stock_status && (
          <div className={`stock-badge ${product.stock_status}`}>
            {product.stock_status === 'instock' ? '✓ In Stock' : 'Out of Stock'}
          </div>
        )}
      </div>

      <div className="product-info">
        <h4 className="product-name" title={product.name}>
          {product.name}
        </h4>
        
        {product.short_description && (
          <p className="product-description">
            {stripHtml(product.short_description).substring(0, 80)}
            {stripHtml(product.short_description).length > 80 ? '...' : ''}
          </p>
        )}

        <div className="product-price-section">
          {hasDiscount ? (
            <div className="price-with-discount">
              <span className="sale-price">₹{product.sale_price}</span>
              <span className="regular-price">₹{product.regular_price}</span>
              <span className="discount-percent">
                {Math.round(((product.regular_price - product.sale_price) / product.regular_price) * 100)}% OFF
              </span>
            </div>
          ) : (
            <span className="current-price">₹{product.price}</span>
          )}
        </div>

        <button className="view-product-btn">
          <FiShoppingCart size={16} /> View Product <FiExternalLink size={14} />
        </button>
      </div>
    </div>
  );
};

export default ProductCard;
